import apiRequest from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { setLoading, setSnack } from 'utilities/redux.actions';

export default function* (action) {
    const {
        meta: { handleSubmit = () => {} },
        payload: { emp, reportingManager }
    } = action;

    yield put(setLoading(true));

    let formData = new FormData();
    formData.append('reportingManager', reportingManager);
    try {
        const { data } = yield call(apiRequest, {
            url: `employee/update?email=${emp}`,
            method: 'put',
            data: formData
        });
        yield put(
            setSnack({
                message: 'ManagerUpdated',
                type: 'success'
            })
        );

        yield put(setLoading(false));
        handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        yield put(
            setSnack({
                message: error?.response?.data?.message || error?.message,
                type: 'error'
            })
        );
    }
}
